/** @jsxImportSource @emotion/react */
import { ForwardedRef, ReactNode, forwardRef } from 'react';
import { useTheme } from '../../ThemeProvider';
import { Sidebar, Props as SidebarProps } from '../Sidebar/Sidebar';

export interface Props extends SidebarProps {
  children?: ReactNode;
  merchantName: string | undefined;
}

export const Navbar = forwardRef(
  (
    { tabs, children, logoutUser, loggedInUser, merchantName }: Props,
    // A forward ref that makes it possible to control the scroll of the text section
    scrollRef: ForwardedRef<HTMLElement>
  ) => {
    const { breakpoints, spacing } = useTheme();
    return (
      <div
        css={{
          display: 'flex',
          flexDirection: 'column-reverse',
          height: '100%',
          width: '100%',
          [breakpoints.tabletMedium]: {
            flexDirection: 'row',
            gap: spacing.xxs,
            padding: spacing.xxs,
          },
        }}
      >
        <div css={{ flex: 0 }}>
          <Sidebar
            tabs={tabs}
            logoutUser={logoutUser}
            loggedInUser={loggedInUser}
            merchantName={merchantName}
          />
        </div>
        <section
          ref={scrollRef}
          css={{
            flex: 1,
            overflowY: 'scroll',
            overflowX: 'hidden',
          }}
        >
          {children}
        </section>
      </div>
    );
  }
);

Navbar.displayName = 'Navbar';
